import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

const HairClips = ({ theme }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [hairclips, setHairclips] = useState([]);
    
    //For dynamic imports (better for code splitting)
    useEffect(() => {
        const loadCollectionImages = async () => {
        const images = await loadImages('hairclips');
        setHairclips(images);
        };
        loadCollectionImages();
    }, []);
    

    return (
        <div className='hairClipsPage'>
            <h3>Hair Clips</h3>
            <p>I have a bunch of hair accessories for my thick hair. I'm gonna count hair claw clips and any other hair clips into the same section.</p>
            <ImageGallery
                images={hairclips}
                onImageClick={setSelectedImage}
            />
            <CustomModal
                isOpen={!!selectedImage}
                onRequestClose={() => setSelectedImage(null)}
                theme={theme}
            >
                {selectedImage && (
                    <img 
                    src={selectedImage} 
                    style={{ maxWidth: '100%', maxHeight: '80vh' }} 
                    alt="Enlarged hairclips" 
                    />
                )}      
            </CustomModal>
        </div>
    );
};
export default HairClips;